import { RakutenImageConverter } from '@travel/utils';

const ric = new RakutenImageConverter();

export default ric;
